<template>
    <div class="container">
        <div class="row mt-4">
            <titleArea :title="this.$t('menus.zkpsh.prosecutors.title1')" />
            <div class="col sm-12 col-md-8 col-lg-5">
                <ProfileCard
                    :title="persecutor_chief.title"
                    :avatar="persecutor_chief.img"
                    :fullname="persecutor_chief.fullname"
                    :position="persecutor_chief.position"
                    :birthday="persecutor_chief.birthday"
                    :address="persecutor_chief.address"
                    :cv_text="persecutor_chief.cv_text"
                    facebook="#"
                    @primary="pranoFunksioni"
                    @secondary="anuloFunksioni" />
            </div>
        </div>
        <h4 class="mt-4">{{this.$t('menus.zkpsh.prosecutors.title2')}}</h4>
        <div class="row mt-4">
            <div class="col sm-12 col-md-8 col-lg-5">
                <persecutor 
                    :title="persecutor.title"
                    :avatar="persecutor.img"
                    :fullname="persecutor.fullname"
                    :position="persecutor.position"
                    :birthday="persecutor.birthday"
                    :address="persecutor.address"
                    :cv_text="persecutor.cv_text"
                    facebook="#"
                    @primary="pranoFunksioni"
                    @secondary="anuloFunksioni"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ProfileCard from '../share/PresecutorChiefTemplate.vue'
import Persecutor from '../share/PersecutorTemplate.vue'
import titleArea from '../../components/share/TitleArea.vue'

export default {
    data() {
        return {
            persecutor_chief: {
                title:"Kryeprokuror",
                img:require('@/assets/AllSystem/zkpsh/BesimKelmendi.png'),
                fullname: "Besim S.Kelmendi",
                position: "Kryeprokuror",
                birthday: "21.03.1962",
                address: "Prishtine",
                cv_text: `TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI `, // CV përshkrimi
            },
            persecutor: {
                title:"Prokuror",
                img:require('@/assets/AllSystem/zkpsh/BesimKelmendi.png'),
                fullname: "Besim S.Kelmendi",
                position: "Prokuror",
                birthday: "21.03.1962",
                address: "Prishtine",
                cv_text: `TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI TEKSTI PER BIOGRAFI `, // CV përshkrimi
            }
        }
    },
    components: {
        ProfileCard,
        Persecutor,
        titleArea
    },
    methods: {
        pranoFunksioni() { console.log("Pranoj") },
        anuloFunksioni() { console.log("Mbyll") }
    }
}
</script>
